import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router, Switch, Route, useLocation, useHistory } from 'react-router-dom';
import Notifications from 'react-notify-toast';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { ErrorFallback, ScrollTopBottom } from './components';
import { store, persistor } from './redux/store';
import {
  NotFound,
  SipTransactions,
  SipTransactionsSuccess,
  OneTimeTransactions,
  OneTimeTransactionsSuccess,
  SignIn,
} from './screens';
import './scss/_styles.scss';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const ENVIRONMENT = process.env.REACT_APP_ENV || 'development';
const IS_PRODUCTION = process.env.REACT_APP_ENV === 'production';
const REAL_PIXEL_KEY = '2604911626425576';

class App extends Component {
  constructor(props) {
    super(props);

    this.store = store;
    this.persistor = persistor;
    global.store = this.store;

    ReactGA.initialize('G-LGFJBZTB7Y');

    ReactPixel.init(
      IS_PRODUCTION ? REAL_PIXEL_KEY : 'fake-pixel-key',
      {},
      {
        autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
        debug: false, // enable logs
      },
    );

    this._initSentry();
  }

  _initSentry = () => {
    if (ENVIRONMENT === 'production') {
      const { email, phoneNumber, uuid } = this.store?.getState()?.user || {};

      Sentry.init({
        dsn: SENTRY_DSN,
        environment: ENVIRONMENT,
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
      });

      Sentry.setUser({ id: uuid, email, phoneNumber });
    }
  };

  render() {
    return (
      <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog>
        <Provider store={this.store}>
          <PersistGate persistor={this.persistor}>
            <Notifications />
            <div className="savvy-main">
              <Router>
                <Switch>
                  <Route path="*">
                    <AnimatedSwitch />
                  </Route>
                </Switch>
              </Router>
            </div>
          </PersistGate>
        </Provider>
      </Sentry.ErrorBoundary>
    );
  }
}

function AnimatedSwitch() {
  const location = useLocation();
  const history = useHistory();

  return (
    <div>
      <Switch location={location}>
        <Route exact path="/" render={() => history.push('/transaction/one-time')} />
        <Route exact path="/transaction/one-time" component={OneTimeTransactions} />
        <Route exact path="/transaction/one-time/success" component={OneTimeTransactionsSuccess} />
        <Route exact path="/transaction/sip" component={SipTransactions} />
        <Route exact path="/transaction/sip" component={SipTransactions} />
        <Route exact path="/transaction/sip/success" component={SipTransactionsSuccess} />
        <Route exact path="/sign-in" component={SignIn} />
        <Route path="*" component={NotFound} />
      </Switch>
      <ScrollTopBottom />
    </div>
  );
}

export default App;
